var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgNeuralIcon = function SvgNeuralIcon(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 440 459"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    stroke: "currentColor",
    strokeLinecap: "square",
    strokeWidth: 16,
    d: "M220.5 49.5v361M37 316l183.5 97.5M214.5 49.5 45 346M49 123l167.5 287.5M220.5 49.5 44 138M220.5 42.5 396 223M221 419l175-181"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 391,
    cy: 229,
    r: 49,
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 220,
    cy: 49,
    r: 49,
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 49,
    cy: 129,
    r: 49,
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 49,
    cy: 330,
    r: 49,
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 220,
    cy: 229,
    r: 49,
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 220,
    cy: 410,
    r: 49,
    fill: "currentColor"
  }))));
};
export default SvgNeuralIcon;